<template>
    <v-card>
        <v-form ref="claimFileForm" v-model="isValid">
            <v-card-text>
                <v-container class="pb-0" fluid>
                    <v-row class="pb-0">
                        <v-col cols="12">
                            <v-select
                                :disabled="isLoading || claimFile.isVerified"
                                :items="claimFileTypes"
                                :rules="[(v) => v !== undefined || 'required']"
                                clearable
                                item-text="value"
                                item-value="key"
                                label="File Type"
                                v-model="claimFile.claimFileType"
                                @change="claimfile.isVerified = false"
                            ></v-select>
                        </v-col>

                        <v-col cols="12">
                            <v-switch
                                :disabled="isLoading || isServiceProviderUser"
                                class="mb-0"
                                label="Verified"
                                v-model="claimFile.isVerified"
                            ></v-switch>
                        </v-col>

                        <v-col cols="12">
                            <v-switch
                                :disabled="isLoading || isServiceProviderUser"
                                class="mb-0"
                                label="Valid Indefinitely"
                                v-model="indefinitelyValid"
                            ></v-switch>
                        </v-col>

                        <v-col cols="12" v-show="!indefinitelyValid">
                            <v-menu
                                :close-on-content-click="false"
                                :disabled="isLoading || isServiceProviderUser"
                                :nudge-right="40"
                                min-width="290px"
                                offset-y
                                transition="scale-transition"
                                v-model="validUntilDateMenu"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        :rules="[
                                            (v) =>
                                                !!v ||
                                                !!indefinitelyValid ||
                                                'required',
                                        ]"
                                        label="Valid Until"
                                        prepend-icon="mdi-calendar-month"
                                        readonly
                                        v-bind="attrs"
                                        v-model="claimFile.validUntil"
                                        v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    @input="validUntilDateMenu = false"
                                    v-model="claimFile.validUntil"
                                ></v-date-picker>
                            </v-menu>
                        </v-col>

                        <v-col cols="12" v-show="!claimFile.id">
                            <FileUploadDragNDrop
                                :disabled="isLoading"
                                accept="image/png, image/jpeg, image/bmp, application/pdf"
                                label="File"
                                placeholder="Select a file"
                                v-model="newFile"
                            ></FileUploadDragNDrop>
                            <div style="color: red" v-show="!fileAvailable">
                                you have to select a file to add a file
                            </div>
                        </v-col>
                    </v-row>
                    <v-row
                        align="end"
                        class="pt-0"
                        justify="space-between"
                        no-gutters
                    >
                        <v-btn
                            :disabled="isLoading && !isDeleting"
                            :loading="isDeleting"
                            @click="deleteEntity"
                            class="text-none"
                            color="warning darken-1"
                            text
                            v-show="claimFile.id > 0"
                            >Delete</v-btn
                        >
                        <v-btn
                            :disabled="isLoading"
                            @click="closeForm"
                            class="text-none"
                            color="secondary darken-1"
                            text
                            >Close</v-btn
                        >
                        <v-btn
                            :disabled="isLoading && !isSaving"
                            :loading="isSaving"
                            @click="saveEntity"
                            class="text-none"
                            color="secondary darken-1"
                            text
                            >{{ claimFile.id > 0 ? "Update" : "Add" }}</v-btn
                        >
                    </v-row>
                </v-container>
            </v-card-text>
        </v-form>
        <v-snackbar
            :color="notifyColor"
            :timeout="15000"
            top
            v-model="notifyShow"
        >
            {{ notifyMessage }}
            <template v-slot:action="{ attrs }">
                <v-btn
                    @click="notifyShow = false"
                    class="text-none"
                    icon
                    v-bind="attrs"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </template>
        </v-snackbar>
    </v-card>
</template>

<script>
import ClaimFile from "../../models/ClaimFile.model";
import dateToString from "../../helpers/dateToString";
import RoleType from "../../constants/RoleType.constant";
import FileUploadDragNDrop from "../FileUploadDragNDrop.vue";
export default {
    props: {
        claimFileIn: Object,
    },
    components: {
        FileUploadDragNDrop
        //
    },
    computed: {
        fileAvailable: function () {
            if (this.claimFile.fileId > 0) return true;

            return !!this.newFile;
        },
        isServiceProviderUser: function () {
            return (
                this.userRoles.findIndex(
                    (x) => x == RoleType.ServiceProviderUser
                ) > -1
            );
        },
    },
    created: async function () {
        this.userRoles = await this.$store.dispatch(
            "authentication/getUserRoles"
        );
        this.claimFileTypes = await this.$store.dispatch(
            "claims/getFileTypes"
        );
        this.claimFile = this.loadEntity(this.claimFileIn);
    },
    data() {
        return {
            claimFile: new ClaimFile(),
            userRoles: [],
            claimFileTypes: [],
            newFile: null,
            validUntilDateMenu: false,
            isValid: null,
            isLoading: null,
            isSaving: null,
            isDeleting: null,
            notifyShow: null,
            notifyMessage: null,
            indefinitelyValid: null,
            notifyColor: null,
            requiredRule: (v) => !!v || "required",
            lengthRule: (limit) => (v) =>
                !v || v.length <= limit || "exceeds " + limit + " characters",
        };
    },
    methods: {
        loadEntity(loadIdentity) {
            var toLoad = new ClaimFile().set(loadIdentity);

            toLoad.validUntil = dateToString(
                toLoad.validUntil ? new Date(toLoad.validUntil) : null
            );

            if (toLoad.validUntil == null) this.indefinitelyValid = true;

            return toLoad;
        },
        //emitters      ------------------------------------------------------------
        emitSavedEntity(savedClaimFile) {
            this.$emit("saved", savedClaimFile);
        },
        emitDeletedEntity(deletedClaimFile) {
            this.$emit("deleted", deletedClaimFile);
        },
        emitCloseForm() {
            this.$emit("close");
        },
        //general       ------------------------------------------------------------
        notify(message, color) {
            this.notifyShow = true;
            this.notifyMessage = message;
            this.notifyColor = color;
        },
        closeForm() {
            this.notifyShow = false;
            this.emitCloseForm();
        },
        validateForm() {
            this.isValid = this.$refs.claimFileForm.validate();
            return this.isValid && this.fileAvailable;
        },
        //save      ------------------------------------------------------------
        saveEntity() {
            if (this.validateForm()) {
                this.isLoading = true;
                this.isSaving = true;

                var entityOut = new ClaimFile().set(this.claimFile);
                if (this.indefinitelyValid) entityOut.validUntil = null;

                (this.claimFile.id == 0
                    ? this.createEntity(entityOut)
                    : this.updateEntity(entityOut)
                )
                    .then(
                        (response) => {
                            this.notify(
                                "ClaimFile successfully saved.",
                                "success"
                            );
                            if (this.claimFile.id == 0) {
                                this.claimFile.id = response.id;
                            }
                            this.emitSavedEntity(response);
                        },
                        (error) => this.notify(error.response.data, "error")
                    )
                    .finally(this.saveEntityDone);
            }
        },
        saveEntityDone() {
            this.isLoading = false;
            this.isSaving = false;
        },
        createEntity(entityOut) {
            var formdata = new FormData();
            formdata.append("NewFile", this.newFile);
            formdata.append("Model", JSON.stringify(entityOut));

            const parameters = {
                formdata: formdata,
                claimId: entityOut.claimId,
            };

            return this.$store.dispatch("claims/createFile", parameters);
        },
        updateEntity(entityOut) {
            return this.$store.dispatch("claims/updateFile", entityOut);
        },
        //delete        ------------------------------------------------------------
        deleteEntity() {
            var isConfirmed = confirm(
                "Are you sure you want to delete this claim file?"
            );
            if (isConfirmed) {
                this.isLoading = true;
                this.isDeleting = true;
                this.$store
                    .dispatch("claims/deleteFile", {
                        claimId: this.claimFile.claimId,
                        claimFileId: this.claimFile.id,
                    })
                    .then(
                        () => {
                            this.notify(
                                "ClaimFile successfully deleted.",
                                "success"
                            );
                            this.emitDeletedEntity(this.claimFile);
                            this.closeForm();
                        },
                        (error) => this.notify(error.response.data, "error")
                    )
                    .finally(this.deleteEntityDone);
            }
        },
        deleteEntityDone() {
            this.isLoading = false;
            this.isDeleting = false;
        },
    },
};
</script>

<style lang="stylus" scoped></style>